var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex border-2 justify-center items-center rounded duration-100 cursor-pointer",class:[
    _vm.value === null && !_vm.hovered ? 'border-bordergrey' : '',
    _vm.value === null && _vm.hovered
      ? 'bg-offwhite border-primary mobile:bg-white'
      : '',
    _vm.value === true && !_vm.hovered ? 'bg-primary border-primary' : '',
    _vm.value === true && _vm.hovered ? 'bg-danger border-danger' : '',
    _vm.value === false && !_vm.hovered ? 'bg-white border-danger/50' : '',
    _vm.value === false && _vm.hovered ? 'bg-white border-bordergrey' : '',
    ("h-" + _vm.size + " w-" + _vm.size) ],on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggle.apply(null, arguments)},"mouseenter":function($event){_vm.hovered = true},"mouseleave":function($event){_vm.hovered = false}}},[_c('span',{staticClass:"typcn text-xl leading-none",class:[
      _vm.value === true ? ("text-white typcn-" + _vm.icon) : '',
      _vm.value === null && _vm.hovered ? ("text-primary typcn-" + _vm.icon) : '',
      _vm.value === null && !_vm.hovered ? "text-bordergrey" : '',
      _vm.value === false && !_vm.hovered ? ("text-danger typcn-" + _vm.iconReverse) : '',
      _vm.value === false && _vm.hovered ? ("typcn-" + _vm.iconReverse) : '' ]})])}
var staticRenderFns = []

export { render, staticRenderFns }